import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=7656c92c&"
import script from "./PasswordForgot.vue?vue&type=script&lang=js&"
export * from "./PasswordForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PasswordForgot.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VForm,
})
